import { render, staticRenderFns } from "./dashboard_designhead.vue?vue&type=template&id=b1c2721c"
import script from "./dashboard_designhead.vue?vue&type=script&lang=js"
export * from "./dashboard_designhead.vue?vue&type=script&lang=js"
import style0 from "./dashboard_designhead.vue?vue&type=style&index=0&id=b1c2721c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports